import React, { useState, useEffect, useContext, useRef, useCallback} from 'react';
import * as S from './styles';
import C from '@assets/themes/colors';
import { Profile } from 'oidc-client';
import { useDispatch, useSelector } from 'react-redux';
import { IProps } from './types';
import { IBrandChromeData, IBrandVehicle } from '@state/brands/types';
import { storageAccountName, containerNameBrands } from '@storage/azure-storage-blob';
import { Context } from '@routes/private/Editor/Context';
import Button from '@components/Button';
import ComboBox from '@components/ComboBox';
import Loading from '@components/Loading';
import actions from '@state/actions';
import RadioButtonList, {RadioButtonListItem} from '@components/RadioButtonList';
import { IBrandImage } from '@state/brandsImages/types';
import ImagesList from '../ImagesList';
import { IPickerSearchImagesProperties } from "routes/private/Editor/types";
import selectors from '@state/selectors';
import { AuthContext } from '@utils/DOIgnition/AuthContext';

const VehicleImages: React.FC<IProps> = (props) => {
  const authContext = React.useContext(AuthContext);
  const userData: Profile | null = authContext && authContext.userData ? authContext.userData.profile : null;
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [year, setYear] = useState<string | undefined>(undefined);
  const [make, setMake] = useState<string | undefined>(undefined);
  const [model, setModel] = useState<string | undefined>(undefined);
  const [trim, setTrim] = useState<string | undefined>(undefined);  
  const [data, setData] = useState<string | undefined>(undefined);
  const [selectedData, setSelectedData] = useState<IBrandVehicle | undefined>(undefined);
  const [selectedIndex, setSelectedIndex] = useState<number | undefined>(undefined);
  const [yearOptions, setYearOptions] = useState<string[]>([]);
  const [makeOptions, setMakeOptions] = useState<string[]>([]);
  const [modelOptions, setModelOptions] = useState<string[]>([]);
  const [trimOptions, setTrimOptions] = useState<string[]>([]);
  const [selectedType, setSelectedType] = useState<string>('All');
  const [dataOptions, setDataOptions] = useState<IBrandChromeData[]>([]);
  const [vehicles, setVehicles] = useState<IBrandImage[]>([]);
  const [vehiclesChrome, setVehiclesChrome] = useState<IBrandImage[]>([]);    
  const [viewVehicles, setViewVehicles] = useState<IBrandImage[]>([]);
  const [page, setPage] = useState<number>(0);
  const [getBrand, setGetBrand] = useState(false);
  const [getChrome, setGetChrome] = useState(false);
  const pageSize = 15;
  const context = useContext(Context);    
  const [allowClean, setAllowClean] = useState<boolean>(true);
  const [selectedIndexes, setSelectedIndexes] = useState<number[]>([]);
  const searchResultscounterSearch: any = useSelector(selectors.brandsImages.getCounterBrandImagesSearch);
  const urlBrand =`https://${storageAccountName}.blob.core.windows.net/${containerNameBrands}`;
  let selectedRefs = React.useRef([] as any);
  const stateRef = useRef<boolean>();

  useEffect(() => {
    if (stateRef) stateRef.current = allowClean;
  }, [allowClean]);
  
  //let oem = context.editorStatus.currentPicker==="BrandLibrary"?(context.entityInformation as ITemplate).tags.oem:undefined;
  let oem : string | undefined = undefined;
  

  let jbOpt: RadioButtonListItem ={
    id:"Jellybean",  
    name:"Transparent Background",
    checked:selectedType==="Jellybean",
    enable: true,


  };
  let stOpt: RadioButtonListItem ={
    id:"Stock",  
    name:"Stock Only",
    checked: selectedType==="Stock",    
    enable: true  
  };
  let allOpt: RadioButtonListItem ={
    id:"All",
    name:"All",
    checked:selectedType==="All",
    enable: true
  }


  let radioOptions : RadioButtonListItem[] = [jbOpt,stOpt, allOpt]
  
  const dispatch = useDispatch();


  const fetchYears = () => {
    return new Promise((resolve, reject) => {
      dispatch(actions.brands.fetchYears(oem,JSON.stringify(userData),(result, error) => {
        if (error) reject(error)
        else resolve(result)
      }))
    });
  }

  const fetchMakes = (year: string) => {
    return new Promise((resolve, reject) => {
      dispatch(actions.brands.fetchMakes(year, userData?.email, userData?.role, (result, error) => {
        if (error) reject(error)
        else resolve(result)
      }))
    });
  }

  const fetchModels = (year: string, make: string) => {
    return new Promise((resolve, reject) => {
      dispatch(actions.brands.fetchModels(year, make,oem, (result, error) => {
        if (error) reject(error)
        else resolve(result)
      }))
    });
  }

  const fetchTrims = (year: string, make: string, model: string) => {
    return new Promise((resolve, reject) => {
      dispatch(actions.brands.fetchTrims(year, make, model,oem, (result, error) => {
        if (error) reject(error)
        else resolve(result)
      }))
    });
  }

  const fetchVehicles = (year: string, make: string, model: string, trim: string, type: string, start:number, length:number ) => {    
    setIsLoading(true)    
    let pickerProperties : IPickerSearchImagesProperties = (context.editorStatus.pickerProperties as IPickerSearchImagesProperties);
    oem = pickerProperties?.search ? undefined : oem;
    return new Promise((resolve, reject) => {      
      dispatch(actions.brandsImages.fetchBrandsVehicles(year, make, model,trim,type, start,length, oem, pickerProperties?.search?.trim().toLocaleLowerCase()??undefined,JSON.stringify(userData),(result, error) => {      
        
        setIsLoading(false)        
        if (error) reject(error)
        else {          
          setGetBrand(true);
          resolve(result)}

      }))
    });
  }

  const fetchVehiclesChromeData = (year: string, make: string, model: string, trim: string, type: string) => {
    setGetChrome(true)
    setIsLoading(true)    
    return new Promise((resolve, reject) => {      
      dispatch(actions.brandsImages.fetchBrandsVehiclesChromeData(year, make, model,trim,type, (result, error) => {      
        setIsLoading(false)
        if (error) reject(error)
        else {          
          resolve(result)}

      }))
    });
  }

  const fetchCounter = () => {
    let pickerProperties : IPickerSearchImagesProperties = (context.editorStatus.pickerProperties as IPickerSearchImagesProperties);
    let query: string = pickerProperties?.search ? `c.status='ACTIVE' and udf.searchMetadataBrandImage("${pickerProperties?.search}", c)`:`c.status='ACTIVE'`;
    if (year) query += ` and c.year='${year}'`;
    if (make) query += ` and c.make='${make}'`;
    if (model) query += ` and c.model='${model}'`;
    if (trim) query += ` and c.trim='${trim}'`;
    if (selectedType!=="All") query += ` and EXISTS (SELECT VALUE a FROM a IN c.types WHERE a['value'] = '${selectedType}' and a.id = 'type')`;
    //if (selectedType!=="All") query += ` and c.types[0] = { 'id': 'type','value': '${selectedType}'}`;
    return new Promise((resolve, reject) => {      
      dispatch(actions.brandsImages.fetchCounterBrandImages(`?filter=${query}`, 'search',  (result, error) => {      
        if (error) reject(error)
        else {       
          resolve(result)}
      }))
    });
  }

  useEffect(() => {        
    if (year && make && model) fetchCounter();
  },[year, make, model, trim, selectedType])

  const reloadCounter = () => {
    if (context.editorStatus.pickerProperties) {
      const run = async () => { await fetchCounter();
      }
      run();
    }
  }
  
  const clean = (id: string) => {
    setPage(0)
    setVehicles([])
    setVehiclesChrome([])
    setViewVehicles([])
    setGetBrand(false)
    setGetChrome(false)
    //if (id!=='trim') {
    //  setTrim("");
   //   if (id!=='model') setTrimOptions([])
    //}
    if (id==="year"){
      setMake("");
      setMakeOptions([])

    }
    if (id==='make' || id=="year") {
      setModel("");
      setModelOptions([])
    }
    if (id==='make' || id==='year' || id=="model") {
      setTrim("");           
      setTrimOptions([])
    };  
  }

  const handleSelectOption = async(id: string, value: string) => {
    clean(id);
    if (id==="year") setYear(value);
    if (id==="make") setMake(value);
    if (id==="model") setModel(value);
    if (id==="trim") setTrim(value);  
    if (id==="type") setSelectedType(value);  

    try {
      if (id==="year") {
        const makes = await fetchMakes(value) as string[];
        if (makes) setMakeOptions(makes);
      }
      if (id==="make" && year) {
        const models: any = await fetchModels(year, encodeURIComponent(value)); 
        if (models) setModelOptions(models);
      }

      if (id==="model" && year && make) {
        const trims: any = await fetchTrims(year, encodeURIComponent(make), encodeURIComponent(value)); 
        if (trims) setTrimOptions(["",...trims]);        
        const data: any = await fetchVehicles(year, encodeURIComponent(make), encodeURIComponent(value) ,"", selectedType,0,pageSize);         
        if (data) setVehicles(data);
      }
      if (id==="trim" && year && make && model) {                    
        const data: any = await fetchVehicles(year, encodeURIComponent(make), encodeURIComponent(model) , encodeURIComponent(value), selectedType, 0, pageSize);         
        if (data) setVehicles(data);        
      }
      if (id==="type" && year && make && model) {        
        const data: any = await fetchVehicles(year, encodeURIComponent(make), encodeURIComponent(model), encodeURIComponent(trim??"") , encodeURIComponent(value), 0, pageSize);         
        if (data) setVehicles(data);
      }

    } catch(error) {
      console.error(error);
    }
  }

  async function getVehiclesChrome() {
    if (year && model && make )
    {            
      const data: any = await fetchVehiclesChromeData(year, encodeURIComponent(make), encodeURIComponent(model), encodeURIComponent(trim??"") , encodeURIComponent(selectedType));         
      if (data) setVehiclesChrome(data);         
    }
  }

  useEffect(() => {        
    
 
    if (vehicles.length>0 )
    {             
      let newarray = [...viewVehicles, ...vehicles];    
      setViewVehicles(newarray);
    }
    if (vehicles.length<pageSize && getBrand && !getChrome && !oem)
    {
      getVehiclesChrome();
    }

    
  },[vehicles])



  useEffect(() => {
    if (vehiclesChrome.length>0 )
    {       
      let newarray = [...viewVehicles, ...vehiclesChrome!];    
      setViewVehicles(newarray);
    }

  },[vehiclesChrome])

  useEffect(() => {
    if (selectedData) {

    }

  },[selectedData]  )

  useEffect(() => {    
    const run = async () => {     
      try {
        const years: any = await fetchYears(); 
        if (years) setYearOptions(years);
      } catch(error) {
        console.error(error);
      }
    }
    run();
}, [])

const metaComboBox = (value: string | undefined, title: string, required: boolean, options: string[]) => {
  return (
    <ComboBox
      id={title.toLowerCase()}
      placeholder={`Select ${title}`}
      title={title}
      options={options}
      required={required}
      disabled={false}
      position={"bottom"}
      chooseOption={handleSelectOption}
      //addNewOption={handleAddNewOption}
      value={value}
      containerStyle={{
        padding: "0px",
        width: "256px",
        margin:"0px 50px 0px 0px"
      }}
      titleStyle={{
        fontFamily: "Roboto",
        fontSize: "16px",
        fontWeight: 500,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "normal",
        letterSpacing: "normal",
        textAlign: "left",
        color: "#000",
        margin: "0px 0px 7px 0px",
      }}
    />
  )
}

  const handleFocusBack = () => {    
    setIsSaving(false);
    window.removeEventListener('focus', handleFocusBack);
  }
  const renderEndMessage = () => {
    return(
      <S.EndContainer>
      </S.EndContainer>
    )
  }


  const getDisabled =  () => {
    return selectedData == undefined
  }

  const renderLoaderContainer = () => {
    if (isLoading)
      return(
        <S.LoaderContainer>
          <Loading 
            id={"loading-designs"}
            containerStyle={{justifyContent: 'center'}}
          />
        </S.LoaderContainer>
      );
    //}
  }



  const handleScroll = async(e: any) => {
    const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    if (bottom && year && make && model && !getChrome) {      
      const data: any = await fetchVehicles(year, encodeURIComponent(make), encodeURIComponent(model), encodeURIComponent(trim??"") , encodeURIComponent(selectedType), (page + pageSize), pageSize);         
      if (data) setVehicles(data);
      setPage(page+pageSize); 
    }
  }

  const getImageSrc = (data:IBrandImage)=>{    

    if (data.id=="" || data.id== undefined)
      return data.srcImage;
    else
    {      
      return `${urlBrand}/${data.brandId}/${data.imageType.toLowerCase()}/${data.srcImage}` + "TN";
    }

  }
  const getImageName =(url:string) =>{
    if (url!==undefined) 
    {
      let urlarray = url.split('/');
      return urlarray[urlarray.length-1];
    }
    else
      return "";



  }

  return (
    <>   
      <S.Content>
        { (props.showDescription??true) &&
        <S.Description>
          {
            `Select the year, make, and model of the vehicle you are looking for. `
          }
        </S.Description>
        }
        { context.editorStatus.pickerProperties && <S.SearchText>
            {searchResultscounterSearch?.counter ? `${searchResultscounterSearch.counter} Result${searchResultscounterSearch.counter>1 ? 's':''} for “${(context.editorStatus?.pickerProperties as IPickerSearchImagesProperties).search}”` : `...`}
        </S.SearchText> }
        <S.LoadContainer>               
            <S.Container>

              <S.Row>
                {metaComboBox(year, "Year", true, yearOptions)}
                {metaComboBox(make, "Make", true, makeOptions)}
                {metaComboBox(model, "Model",true,  modelOptions)}
                {metaComboBox(trim, "Trim",false, trimOptions)}
              </S.Row>
              <S.radioContainer>
          
                <RadioButtonList 
                      name="rblLocations" 
                      RadioButtonListItems = {radioOptions}                    
                      onSelectedItem = {(selectedValue:any) => {                              
                        handleSelectOption("type",selectedValue);
                      }}                   
                  />            
              </S.radioContainer>       
            </S.Container>                         
        </S.LoadContainer>
        <ImagesList
          onScroll={(e:any)=>handleScroll(e)}
          imagesList={viewVehicles}
          isLoading={isLoading}
          setAllowClean={setAllowClean}
          setSelectedData={setSelectedData}
          selectedIndex={selectedIndex}
          setSelectedIndex={setSelectedIndex}
          selectedIndexes={selectedIndexes}
          updateImagesList={oem ? setViewVehicles : undefined}
          loadFromBrand={oem ? true : false}
        />
      </S.Content>
      <S.ActionsContainer>
        <S.Action>
          <Button
            label="CANCEL"
            style={{
              width: '112px',
              marginRight: 12,
              backgroundColor: "transparent",
              border: `1px solid ${C.BLUE}`,
              hoverBackgroundColor: `${C.BLUE}22`,
            }}
            labelStyle={{ color: C.BLUE }}
            onClick={() => {props.setOpen(false)}}
            disabled={isSaving ? true : false}            
          />
        </S.Action>
        <S.Action>
          <Button
            label={"ADD"}
            style={{
              width: '112px',
              backgroundColor: true ? C.BLUE : C.GENERIC_GRAY,
              flexGrow: 0,
              hoverBackgroundColor: true ? `${C.BLUE}AA` : `${C.GENERIC_GRAY}AA`,
            }}
            onClick={() => {props.onSelect(selectedData)  }}
            disabled={getDisabled()}
            loading={props.loadingImage}
          />
        </S.Action>
      </S.ActionsContainer>   
    </>
  );
}

export default VehicleImages;